import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe, Location } from '@angular/common';
import { isNumber } from 'highcharts';
import { distinctUntilChanged, debounceTime, tap, filter, switchMap, finalize } from 'rxjs/operators';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, ComunidadService, MonedaService, ServicioGastoService, UnidadFuncionalService, GastoService, ProveedorService, TenantService, AlicuotaIvaService, MovimientoService, ExpensaService } from '../../../../src/app/shared/services';

import { MenuFuncionCodes, SearchComunidadRequest, Comunidad, TipoGasto, SearchMonedaRequest, TipoUnidad, UnidadFuncional, SaveGastoRequestDto, SearchProveedorRequest, Proveedor, TenantFeatureFlags, ExpensaDto,
        AlicuotaIva, SearchAlicuotaIvaRequest, Movimiento, SaveGastoMovimientoDto, DialogCargaMovimientoResponse, DialogCargaMovimientoRequest, DialogCargaMovimientoItem, SearchMovimientoRequest, GastoAdjunto, SaveGastoFromDocumentRequestDto,
        ComunidadTiposGastos, TipoGastoComunidadServicioGasto, SearchServicioGastoRequest, Gasto, DialogConfirmRequest, DialogConfirmResponse,
        GridPageSettings, LocalStorageKeys, Moneda, Consorcio, DialogUnidadFuncionalSearchComponentRequestDto, DialogUnidadFuncionalSearchComponentResponseDto
} from '../../../../src/app/shared/model';

import { DialogUnidadFuncionalSearchComponent } from '../unidad-funcional/components/dialogUnidadFuncionalSearch.component';
import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { DialogCargaMovimientoComponent } from '../movimientos/components/dialogCargaMovimiento.component';

@Component({
    selector: 'app-gastoEdit',
    templateUrl: './gastoEdit.component.html',
    styleUrls: ['./gastoEdit.component.scss']
})

export class GastoEditComponent implements OnInit {

    formGroup: FormGroup;

    @ViewChild('ufSearchGrid')
    public ufSearchGrid: GridComponent;

    ufSearchForm: FormGroup;
    public ufSearchData: DataManager;
    public ufSearchQuery: Query;

    public selectionOptions: SelectionSettingsModel;
    public pageSizes: number[];
    public pageSettings: PageSettingsModel;

    editGastoComunidadAssigned: boolean = false;
    editGastoUfAssigned: boolean = false;
    esGastoComunidad: boolean = false;
    esGastoUf: boolean = false;

    isValidating: boolean = false;
    isSearching: boolean = false;
    isSaving: boolean = false;
    hasSearched: boolean = false;

    canView: boolean = false;
    canAdd: boolean = false;
    canEdit: boolean = false;
    canDelete: boolean = false;
    canEditUf: boolean = false;
    canEditComunidad: boolean = false;
    canAnalizarDoc: boolean = false;
    canRecurrente: boolean = false;

    isAttachmentSearching: boolean = false;
    isGastoUfSearching: boolean = false;
    isGastoComunidadSearching: boolean = false;
    isComunidadSearching: boolean = false;
    isConsorcioSearching: boolean = false;
    isComunidadTipoGastoServicioSearching: boolean = false;
    isTipoGastoComunidadSearching: boolean = false;
    isTipoUnidadSearching: boolean = false;
    isMonedaSearching: boolean = false;
    isFileAttaching: boolean = false;
    isFileAnalyzing: boolean = false;
    isProveedorAutoSearching: boolean = false;
    isAlicuotaIvaSearching: boolean = false;
    isMovimientoSearching: boolean = false;
    isDeudaSaving: boolean = false;
    isDeleting: boolean = false;
    isMovimientosSearching: boolean = false;
    isExpensaLiquidacionSearching: boolean = false;

    canMovimientoAdd: boolean = false;
    canMovimientoView: boolean = false;
    canExpensaView: boolean = false;

    tenantFeatureFlags: TenantFeatureFlags;

    alicuotaIvaList: AlicuotaIva[];
    consorcioList: Consorcio[];
    comunidadList: Comunidad[];
    tipoUnidadList: TipoUnidad[];
    tipoGastoComunidadList: TipoGasto[];
    comunidadTipoGastoServicioList: TipoGastoComunidadServicioGasto[];
    comunidadTipoGastoList: ComunidadTiposGastos[];
    monedaList: Moneda[];
    movimientoList: Movimiento[];
    filteredProveedorList: Proveedor[] = [];

    item: Gasto;
    itemComunidad: Comunidad;
    itemUf: UnidadFuncional | null = null;
    itemMovimiento: Movimiento;
    expensaCabecera: ExpensaDto;

    comunidadId: number | null;

    msgError: string = "";
    step: number = 0;

    montoIva1: number = 0;
    montoIva2: number = 0;
    montoTotal1: number = 0;
    montoTotal2: number = 0;

    constructor(
        private formBuilder: FormBuilder,
        private sharedFunctions: SharedFunctions,
        private router: Router,
        private location: Location,
        private route: ActivatedRoute,
        private menuFuncionService: MenuFuncionService,
        private comunidadService: ComunidadService,
        public dialog: MatDialog,
        private unidadFuncionalService: UnidadFuncionalService,
        private servicioGastoService: ServicioGastoService,
        private monedaService: MonedaService,
        private expensaService: ExpensaService,
        private tenantService: TenantService,
        private proveedorService: ProveedorService,
        private alicuotaIvaService: AlicuotaIvaService,
        private gastoService: GastoService,
        private movimientoService: MovimientoService
    ) {
    }

    ngOnInit(): void {
        this.isValidating = true;
        this.menuFuncionService.checkMenuPadre(MenuFuncionCodes.GASTO).subscribe(data => {

            if (data != null && data.Success && data?.Result && data?.Result.length > 0) {

                this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
                    this.isValidating = false;
                    if (dataTenant != null && dataTenant.Success) {
                        this.tenantFeatureFlags = dataTenant.Result;

                        this.canEdit = data.Result.some(x => x == MenuFuncionCodes.GASTO_EDIT);
                        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.GASTO_ADD);
                        this.canView = data.Result.some(x => x == MenuFuncionCodes.GASTO_LIST);
                        this.canDelete = data.Result.some(x => x == MenuFuncionCodes.GASTO_DELETE);
                        this.canEditComunidad = data.Result.some(x => x == MenuFuncionCodes.GASTO_ASOCIAR_COMUNIDAD);
                        this.canEditUf = data.Result.some(x => x == MenuFuncionCodes.GASTO_ASOCIAR_UF);
                        this.canAnalizarDoc = data.Result.some(x => x == MenuFuncionCodes.GASTO_ANALISIS_DOCUMENTO);
                        this.canRecurrente = data.Result.some(x => x == MenuFuncionCodes.GASTO_RECURRENTES);

                        if (this.canView) {
                            this.loadView();
                        }
                        else {
                            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                            this.onCancel();
                        }
                    }
                    else {
                        this.isValidating = false;
                        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                        this.onCancel();
                    }
                },
                (err: HttpErrorResponse) => {
                    this.isValidating = false;
                    this.sharedFunctions.handleError(err, true);
                })

            }
            else {
                this.menuFuncionService.checkMenu(MenuFuncionCodes.MI_GASTO_LIST).subscribe(data2 => {
                    this.isValidating = false;
                    if (data2 != null && data2.Success && data2.Result != null && data2.Result) {
                        this.canView = true;
                        if (this.canView) {
                            this.loadView();
                        }
                        else {
                            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                            this.onCancel();
                        }
                    }
                    else {
                        this.isValidating = false;
                        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                        this.onCancel();
                    }
                },
                (err: HttpErrorResponse) => {
                    this.isValidating = false;
                    this.sharedFunctions.handleError(err, true);
                })
            }
        },
        (err: HttpErrorResponse) => {
            this.isValidating = false;
            this.sharedFunctions.handleError(err, true);
        });
    }

    loadView() {
        this.buildForm();

        this.pageSizes = GridPageSettings.PageSizeList;
        this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };

        this.ufSearchData = new DataManager({
            url: this.unidadFuncionalService.getSearchUrl(),
            adaptor: new WebApiAdaptor(),
            headers: [this.unidadFuncionalService.getAuthorizationHeader(),this.unidadFuncionalService.getTenantHeader()]
        });

        this.menuFuncionService.checkMenuPadre(MenuFuncionCodes.MOVIMIENTO).subscribe(data => {
            if (data != null && data.Success && data?.Result) {
              this.canMovimientoAdd = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_DEUDA);
              this.canMovimientoView = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_LIST);
            }
        },
        (err: HttpErrorResponse) => {
            this.sharedFunctions.handleError(err);
        });

        this.menuFuncionService.checkMenuPadre(MenuFuncionCodes.EXPENSA).subscribe(data => {
            if (data != null && data.Success && data?.Result) {
              this.canExpensaView = data.Result != null && data.Result.length > 0;
            }
        },
        (err: HttpErrorResponse) => {
            this.sharedFunctions.handleError(err);
        });

        if (this.canEditComunidad && !this.canEditUf) {
            this.loadComunidadView();
        }
        else if(this.canEditUf && !this.canEditComunidad) {
            this.loadUfView();
        }

        this.getProveedoresAutocomplete();
        this.loadEntity();
    }

    buildForm() {
        this.formGroup = this.formBuilder.group({
            'TipoGastoComunidad': [null, Validators.required],
            'TipoGastoId': [null],
            'ServicioGastoId': [null],
            'FechaGasto': [null, Validators.required],

            'FechaVencimiento': [null, Validators.required],
            'FechaVencimiento2': [null],

            'Detalle': [null, [Validators.required, Validators.maxLength(150)]],
            'Observaciones': [null, Validators.maxLength(300)],

            'AlicuotaIvaId': [null],
            'MonedaId': [null, Validators.required],
            'ImporteBase': [null, Validators.required],
            'ImporteBase2': [null],
            'PermitirGenerarInteres': [null],

            'Proveedor': [null],
            'ConsorcioId': [null],
            'Comunidad': [null],
            'ComunidadId': [null],
            'UnidadFuncional': [null],
            'UnidadFuncionalId': [null],

            'EsRecurrente': [false, Validators.required],
            'PeriodicidadRecurrencia': [null],

            //Configuraciones de movimiento
            'TipoMovimientoId': [null],
            'CantidadCuotas': [1, Validators.min(1)],
            'FechaInicioCuota': [new Date()],
            'DiasRepeticionCuotas': [30],
            'PorcentajeAjusteCuota': [0, [Validators.min(0), Validators.max(100)]],
            'AplicarAjusteIncremental': [false],
        });

        if (this.tenantFeatureFlags?.HabilitarControlCaja) {
            const alicuotaIvaControl = this.formGroup.get('AlicuotaIvaId');

            alicuotaIvaControl?.setValidators([Validators.required]);
            alicuotaIvaControl?.updateValueAndValidity();
        }
    }

    loadEntity() {
        this.route.params.subscribe(params => {
          if (params['id'] != null && params['id'] != '0') {
            var id = Number(params['id']);

            if (id > 0) {
                if (this.canView || this.canEdit) {
                    this.isSearching = true;
                    this.gastoService.get(id).subscribe(data => {
                        this.isSearching = false;
                        if (data != null && data.Success) {
                            this.item = data.Result;

                            if (this.item != null && this.item.Id > 0) {
                                this.loadGastoData();
                            }
                            else
                                this.msgError = "No se encontró el gasto seleccionado.";
                        }
                        else
                            this.msgError = "Ocurrió un error al intentar obtener los datos del gasto.";
                    },
                    (err: HttpErrorResponse) => {
                        this.isSearching = false;
                        this.sharedFunctions.handleError(err, true);
                    })
                }
                else {
                    this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                    this.onCancel();
                }
            }
            else
              this.msgError = "Item no válido.";
          }
          else
          {
            if (this.canAdd) {
                this.item = new Gasto(0, null, null, null, null, null, new Date(), new Date(), new Date(), null, null, null, null, null, null, null, null, null, null, null, null, null, true, 0, null, null, null, null, null, null, false, null, this.canAdd && (this.canEditComunidad || this.canEditUf), []);
                this.formGroup.patchValue(this.item);
            }
            else {
                this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                this.onCancel();
            }
          }
        });
    }

    loadGastoData() {
        if (this.item.Id != null && this.item.Id > 0) {
            this.canAdd = this.item.Editable;
            this.canEdit = this.item.Editable;

            if (this.item.UnidadFuncionalId != null && this.item.UnidadFuncionalId > 0) {
                this.loadUfView();
                this.loadUf(this.item.UnidadFuncionalId);
            }
            else {
                if(this.item.ComunidadId !== null)
                  this.comunidadId = this.item.ComunidadId;
                this.loadComunidadView();
            }

            this.getTiposGastosByComunidad(true);
            this.loadAttachments(this.item.Id);
            this.loadExpensaLiquidacion(this.item.ExpensaCabeceraId);
            this.getMovimientos(this.item.Id);

            if (this.canEdit) {
                this.formGroup.patchValue(this.item);

                if (this.item.ComunidadId != null && this.item.ComunidadId > 0)
                    this.formGroup.get("Comunidad")?.setValue(this.comunidadList?.find(f => f.Id == this.item.ComunidadId));

                this.montoIva1 = this.item.ImporteAlicuotaIva ?? 0;
                this.montoIva2 = this.item.ImporteAlicuotaIva2 ?? 0;

                this.montoTotal1 = this.item.Importe ?? 0;
                this.montoTotal2 = this.item.Importe2 ?? 0;

                if (this.item.ProveedorId != null && this.item.ProveedorId > 0) {
                    this.filteredProveedorList = [new Proveedor
                    (
                        this.item.ProveedorId, null,
                        this.item.ProveedorNombre,
                        null,null,null,null,null,null,null,null,null,null,null,null,null,null,[]
                    )];
                    this.formGroup.get("Proveedor")?.setValue(this.filteredProveedorList[0]);
                }

                this.loadComunidadTipoGastoServicios(this.item.TipoGastoComunidad?.Id);

                this.loadStep2();
                this.step = 2;
            }
            else {
                if (this.item.ComunidadId != null && this.item.ComunidadId > 0)
                    this.loadComunidad(this.item.ComunidadId);
            }
        }
        else
            this.msgError = "No se encontró el gasto seleccionado.";
    }

    loadAttachments(id) {
        this.isAttachmentSearching = true;
        this.gastoService.getAttachments(id).subscribe(data => {
          this.isAttachmentSearching = false;
          this.item.Adjuntos = data.Result;
        },
        (err: HttpErrorResponse) => {
          this.isAttachmentSearching = false;
          this.sharedFunctions.handleError(err);
        })
    }

    loadExpensaLiquidacion(id) {
        this.isExpensaLiquidacionSearching = true;
        this.expensaService.get(id).subscribe(data => {
          this.isExpensaLiquidacionSearching = false;
          this.expensaCabecera = data.Result;
        },
        (err: HttpErrorResponse) => {
          this.isExpensaLiquidacionSearching = false;
          this.sharedFunctions.handleError(err);
        })
    }

    loadUf(ufId) {
        this.isGastoUfSearching = true;
        this.unidadFuncionalService.get(ufId).subscribe(data => {
          this.isGastoUfSearching = false;
          if (data != null && data.Success) {
            this.itemUf = data.Result;

            this.formGroup.get("UnidadFuncional")?.setValue(data.Result);
            this.formGroup.get("UnidadFuncionalId")?.setValue(data.Result?.Id);

            if (this.item.UnidadFuncionalId != null && this.item.UnidadFuncionalId > 0) {
                this.comunidadId = this.itemUf.ComunidadId;
                this.getTiposGastosByComunidad(true);
            }
          }
        },
        (err: HttpErrorResponse) => {
          this.isGastoUfSearching = false;
          this.sharedFunctions.handleError(err);
        })
    }

    loadComunidad(comunidadId) {
        this.isGastoComunidadSearching = true;
        this.comunidadService.get(comunidadId).subscribe(data => {
          this.isGastoComunidadSearching = false;
          if (data != null && data.Success)
            this.itemComunidad = data.Result;
        },
        (err: HttpErrorResponse) => {
          this.isGastoComunidadSearching = false;
          this.sharedFunctions.handleError(err);
        })
    }

    onWheel(event: WheelEvent) {
        (event.target as HTMLElement).blur();
        event.preventDefault();
      }

    setStep(index: number) {

        if (index == 2 && this.step != 2) {
            if (this.hasStep1Completed())
                this.loadStep2();
            else
                index = 1;
        }

        if (index == 1 && this.step != 1) {
            this.loadStep1();
            this.loadStep2();
        }

        this.step = index;
    }

    clearDate(formFieldName: string) {
        if (formFieldName != null && formFieldName.length > 0) {
            if (this.formGroup.get(formFieldName) != null && this.formGroup.get(formFieldName)?.value)
                this.formGroup.get(formFieldName)?.setValue(null);
        }
    }

    onCancel() {
        this.location.back();
    }

    onDelete() {
        if (!this.canDelete)
            return;

        if (this.item != null && this.item.Id > 0) {
            const dialogRef = this.dialog.open(DialogConfirmComponent, {
                data: new DialogConfirmRequest("Confirmación de Baja", "¿Está seguro que desea dar de baja el gasto?", "Sí", "No")
            });

            dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
                if (result != null && result.Accepted) {
                    this.isDeleting = true;
                    this.gastoService.delete(this.item.Id).subscribe(data => {
                        this.isDeleting = false;
                        if (data != null && data.Success) {
                            this.onCancel();
                        }
                        else
                            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
                    },
                    (err: HttpErrorResponse) => {
                        this.isDeleting = false;
                        this.sharedFunctions.handleError(err, true);
                    })
                }
            });
        }
        else
            this.sharedFunctions.showMessage("Debe cargar un gasto para poder llevar a cabo la operación", "Error");
    }

//#region Comunidad

    loadComunidadView() {
        this.esGastoComunidad = true;
        this.esGastoUf = false;

        this.itemUf = null;
        this.formGroup.get("UnidadFuncionalId")?.setValue(null);
        this.formGroup.get("UnidadFuncional")?.setValue(null);

        this.setStep(1);
    }

    onComunidadSelect() {
        var c = this.formGroup.get('Comunidad')?.value;
        this.formGroup.get('ComunidadId')?.setValue(c?.Id);
        this.comunidadId = c?.Id;

        this.getTiposGastosByComunidad();
    }

    compareComunidad(o1: Comunidad, o2: Comunidad): boolean {
        return o1?.Id == o2?.Id;
    }

    getErrorComunidad() {
        var v = this.formGroup.get('Comunidad');
        if (v?.hasError('required') && this.esGastoComunidad)
          return 'El campo es obligatorio';
        return '';
    }

//#endregion

//#region UFs

    loadUfView() {
        this.esGastoUf = true;
        this.esGastoComunidad = false;

        this.formGroup.get("ComunidadId")?.setValue(null);
        this.formGroup.get("Comunidad")?.setValue(null);

        this.setStep(1);
    }

    onUfSelect() {
        const dialogRef = this.dialog.open(DialogUnidadFuncionalSearchComponent, {
            width: '90%',
            data: new DialogUnidadFuncionalSearchComponentRequestDto(false, 0, null)
        });

        dialogRef.afterClosed().subscribe((result: DialogUnidadFuncionalSearchComponentResponseDto) => {
            if (result != null && !result.Cancelled) {
                if (result.Items != null && result.Items.length > 0) {
                    this.itemUf = result.Items[0];

                    this.formGroup.get("UnidadFuncionalId")?.setValue(this.itemUf.Id);
                    this.formGroup.get("UnidadFuncional")?.setValue(this.itemUf);

                    this.comunidadId = this.itemUf.ComunidadId;
                    this.getTiposGastosByComunidad();
                }
                else
                    this.sharedFunctions.showMessage("Debe seleccionar una unidad funcional para continuar", "Error");
            }
        });
    }

//#endregion

//#region Paso 1

    loadStep1() {
        if (this.esGastoComunidad) {
            this.getComunidades();
        }

        if (this.esGastoUf) {
            // this.buildUfSearchForm();
            // this.ufSearchGrid.refresh();

            this.getComunidades();
        }
    }

    getComunidades() {
        var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
        if (cId != null && cId.length > 0 && cId > 0)
            cId = Number(cId);

        var r = new SearchComunidadRequest(null, null, true, "Nombre", null, cId, null, null, null, true);
        this.isComunidadSearching = true;

        this.comunidadService.search(r).subscribe(data => {
            this.isComunidadSearching = false;
            this.comunidadList = data?.result;

            if (this.canEdit && this.item != null && this.item.ComunidadId != null && this.item.ComunidadId > 0)
                this.formGroup.get("Comunidad")?.setValue(this.comunidadList?.find(f => f.Id == this.item.ComunidadId));
        },
        (err: HttpErrorResponse) => {
          this.isComunidadSearching = false;
          this.sharedFunctions.handleError(err);
        });
    }

    hasStep1Completed() {
        if (this.esGastoComunidad) {
            var c = this.formGroup.get('Comunidad')?.value;
            if (c == null || c.Id == null || c.Id <= 0) {
                this.sharedFunctions.showMessage("Debe seleccionar una comunidad para continuar", "Error");
                return false;
            }

            this.formGroup.get('ComunidadId')?.setValue(c?.Id);
        }

        if (this.esGastoUf) {
            var uf = this.formGroup.get('UnidadFuncional')?.value;
            if (uf == null || uf.Id == null || uf.Id <= 0) {
               this.sharedFunctions.showMessage("Debe seleccionar una unidad funcional para continuar", "Error");
               return false;
            }

            this.formGroup.get('UnidadFuncionalId')?.setValue(uf?.Id);
        }

        return true;
    }

    // onStep1Guardar() {
    //     if (!this.hasStep1Completed())
    //         return false;

    //     if (this.esGastoComunidad) {
    //         var c = this.formGroup.get('Comunidad')?.value;
    //         this.formGroup.get('ComunidadId')?.setValue(c?.Id);
    //         this.comunidadId = c?.Id;
    //     }

    //     if (this.esGastoUf) {
    //         var uf = this.formGroup.get('UnidadFuncional')?.value;
    //         this.formGroup.get('UnidadFuncionalId')?.setValue(uf?.Id);
    //         this.comunidadId = uf?.ComunidadId;
    //     }

    //     this.setStep(2);
    // }

//#endregion

//#region Paso 2

    loadStep2() {
        this.getTiposGastosByComunidad();
        this.getMonedas();
        this.getAlicuotaIva();
    }

    compareTipoGastosComunidad(o1: ComunidadTiposGastos, o2: ComunidadTiposGastos): boolean {
        return o1?.Id == o2?.Id;
    }

    getTiposGastosByComunidad(setForm: boolean = false) {
        if (this.comunidadId == null || this.comunidadId <= 0)
            return false;

        this.isTipoGastoComunidadSearching = true;
        this.comunidadService.getTiposGasto(this.comunidadId).subscribe(data => {
            this.isTipoGastoComunidadSearching = false;
            this.comunidadTipoGastoList = data?.Result;

            if (setForm && this.comunidadTipoGastoList != null)
                this.formGroup.get("TipoGastoComunidad")?.setValue(this.comunidadTipoGastoList.find(f => f.TipoGastoId == this.item.TipoGastoId));
        },
        (err: HttpErrorResponse) => {
            this.isTipoGastoComunidadSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    getMonedas() {
        var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
        this.isMonedaSearching = true;

        this.monedaService.search(r).subscribe(data => {
            this.isMonedaSearching = false;
            this.monedaList = data?.result;

            this.selectMonedaDefault();
        },
        (err: HttpErrorResponse) => {
            this.isMonedaSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    selectMonedaDefault() {
        if (this.monedaList != null && this.monedaList.length == 1 && (this.item?.MonedaId == null || this.item.MonedaId <= 0)) {
          this.formGroup.get('MonedaId')?.setValue(this.monedaList[0].Id);
        }
    }

    getAlicuotaIva() {
        this.isAlicuotaIvaSearching = true;
        var r = new SearchAlicuotaIvaRequest(null,null,null,null,null,null,null,null,true);

        this.alicuotaIvaService.search(r).subscribe((data)=>{
          this.isAlicuotaIvaSearching = false;
          this.alicuotaIvaList = data?.result;

          this.selectAlicuotaIvaDefault();
        },
        (err: HttpErrorResponse) => {
          this.isAlicuotaIvaSearching = false;
          this.sharedFunctions.handleError(err);
        });
    }

    selectAlicuotaIvaDefault() {
        if (this.alicuotaIvaList != null && (this.item?.AlicuotaIvaId == null || this.item.AlicuotaIvaId <= 0)) {
            this.formGroup.get('AlicuotaIvaId')?.setValue(null);

            if (this.alicuotaIvaList.length == 1)
                this.formGroup.get('AlicuotaIvaId')?.setValue(this.alicuotaIvaList[0]?.Id);
            else
                this.formGroup.get('AlicuotaIvaId')?.setValue(this.alicuotaIvaList.find(f => f.Porcentaje == 0)?.Id);
        }

        this.onAlicuotaIvaSelect();
    }

    getProveedoresAutocomplete() {
        this.formGroup.get('Proveedor')?.valueChanges
          .pipe(
            filter(res => {
              return res && res !== null && res.length >= 3
            }),
            distinctUntilChanged(),
            debounceTime(1000),
            tap(() => {
              this.filteredProveedorList = [];
              this.isProveedorAutoSearching = true;
            }),
            switchMap(value => this.proveedorService.search(new SearchProveedorRequest(null, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
              .pipe(
                finalize(() => {
                  this.isProveedorAutoSearching = false;
                }),
              )
            )
          )
          .subscribe((data: any) => {
            if (data != null && data.result != null)
              this.filteredProveedorList = data.result;
            else
              this.filteredProveedorList = [];
            // (this.filteredProveedorList, 'lista proveedor')
          });
    }

    displayProveedor(proveedor: Proveedor): string {
        return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
    }

    onTipoGastoComunidadSelect() {
        var tipoGastoComunidad = this.formGroup.get("TipoGastoComunidad")?.value;

        this.comunidadTipoGastoServicioList = [];
        this.formGroup.get("ServicioGastoId")?.setValue(null);

        if (tipoGastoComunidad != null && tipoGastoComunidad.Id > 0) {
            this.formGroup.get("TipoGastoId")?.setValue(tipoGastoComunidad.TipoGastoId);
            this.loadComunidadTipoGastoServicios(tipoGastoComunidad.Id);
        }
    }

    loadComunidadTipoGastoServicios(tipoGastoId) {
        var r = new SearchServicioGastoRequest(null, null, true, "Nombre", null, null, null, tipoGastoId, true);
        this.isComunidadTipoGastoServicioSearching = true;

        this.servicioGastoService.search(r).subscribe(data => {
            this.isComunidadTipoGastoServicioSearching = false;
            this.comunidadTipoGastoServicioList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isComunidadTipoGastoServicioSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    getErrorTipoGastoComunidad() {
        var v = this.formGroup.get('TipoGastoComunidad');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorServicioGastoId() {
        var v = this.formGroup.get('ServicioGastoId');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorDetalle() {
        var v = this.formGroup.get('Detalle');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        if (v?.hasError('maxlength'))
          return 'Límite de 150 caracteres alcanzado';
        return '';
    }

    getErrorMonedaId() {
        var v = this.formGroup.get('MonedaId');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorFechaVencimiento() {
        var v = this.formGroup.get('FechaVencimiento');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorFechaVencimiento2() {
        var v = this.formGroup.get('FechaVencimiento2');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorImporte() {
        var v = this.formGroup.get('ImporteBase');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorImporte2() {
        var v = this.formGroup.get('ImporteBase2');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorObservaciones() {
        var v = this.formGroup.get('Observaciones');
        if (v?.hasError('maxlength'))
          return 'Límite de 300 caracteres alcanzado';
        return '';
    }

    getErrorAlicuotaIvaId() {
        var v = this.formGroup.get('AlicuotaIvaId');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    hasStep2Completed() {
        var valid = true;
            // (this.formGroup.get('Nombre')?.valid &&
            // this.formGroup.get('Apellido')?.valid &&
            // this.formGroup.get('TipoDocumentoId')?.valid &&
            // this.formGroup.get('NroDocumento')?.valid &&
            // this.formGroup.get('Cuit')?.valid &&
            // this.formGroup.get('FechaNacimiento')?.valid &&
            // this.formGroup.get('Mail')?.valid &&
            // this.formGroup.get('ConfirmMail')?.valid &&
            // this.formGroup.get('CodigoPais')?.valid &&
            // this.formGroup.get('Movil')?.valid &&
            // this.formGroup.get('Login')?.valid &&
            // this.formGroup.get('Clave')?.valid &&
            // this.formGroup.get('ConfirmClave')?.valid);

        return valid;
    }

    onAlicuotaIvaSelect() {
        this.calcularMontos();
    }

    calcularMontos() {
        var alicuota = this.alicuotaIvaList?.find(f => f.Id == this.formGroup.get("AlicuotaIvaId")?.value);
        if (alicuota != null && alicuota.Id > 0) {
            this.montoIva1 = ((this.formGroup.get("ImporteBase")?.value ?? 0) * (alicuota.Porcentaje / 100));
            this.montoIva2 = ((this.formGroup.get("ImporteBase2")?.value ?? 0) * (alicuota.Porcentaje / 100));

            this.montoTotal1 = (this.formGroup.get("ImporteBase")?.value ?? 0) + this.montoIva1;
            this.montoTotal2 = (this.formGroup.get("ImporteBase2")?.value ?? 0) + this.montoIva2;
        }
        else {
            this.montoIva1 = 0;
            this.montoIva2 = 0;

            this.montoTotal1 = 0;
            this.montoTotal2 = 0;
        }
    }

    onStep2Guardar() {
        if (!this.hasStep1Completed()) {
            this.setStep(1);
            return false;
        }

        if (!this.formGroup.valid) {
            this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
            return false;
          }

        this.saveGasto();
    }

//#endregion

    saveGasto() {
        // if (this.tenantFeatureFlags?.HabilitarControlCaja && !this.tieneMovimientoAsociado())
        //     this.openDialogCargaMovimiento(true);
        // else
        var m = [
            new DialogCargaMovimientoItem(0, this.montoTotal1, null, 1, this.formGroup.get("FechaGasto")?.value, 0, 0, false, false, null, null)
        ];

        this.doSaveGasto(m);
    }

    doSaveGasto(datosMovimiento: DialogCargaMovimientoItem[] = []) {
        var r = new SaveGastoRequestDto(0, null, null, null, null, null, null, null, null, null, null, null, true, null, null, null, null, null, [], []);

        r =
        {
            ...this.formGroup.value,
            ...
            {
                Id: (this.item?.Id ?? 0),
                ProveedorId: this.formGroup.get("Proveedor")?.value?.Id,
                Activo: (this.item?.Activo ?? true),
                Adjuntos: this.item?.Adjuntos,
                Deudas: datosMovimiento
            }
        };

        this.isSaving = true;
        this.gastoService.save(r).subscribe(data => {
            this.isSaving = false;
            if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {

                const dialogRef = this.dialog.open(DialogConfirmComponent, {
                    data: new DialogConfirmRequest(
                        "Confirmación de Operación",
                        "Se guardaron correctamente los datos!<br/><br/>¿Desea cargar otro gasto?",
                        "Sí",
                        "No"
                    )
                });

                dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
                    if (result != null && result.Accepted)
                        this.sharedFunctions.reloadCurrentRoute();
                    else
                        this.onCancel();
                });
            }
            else
                this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
            this.isSaving = false;
            this.sharedFunctions.handleError(err, true);
        })
    }

//#region Adjuntos

    onFileAttachedDelete(item: any) {
        if (item.Id > 0)
            this.onExistingFileAttachedDelete(item);
        else
            this.onNewFileAttachedDelete(item);
    }

    onNewFileAttach(event: any) {
        if (event?.target?.files != null && event.target.files.length > 0) {
            var fileList = event.target.files;

            if (this.item.Adjuntos == null)
                this.item.Adjuntos = [];

            for (var i=0; i<fileList.length; i++) {
                if (this.item.Adjuntos.find(f => f.NombreDocumento == fileList[i].name)) {
                    this.sharedFunctions.showMessage("Ya existe un archivo con ese nombre. Por favor modifique el nombre del archivo o elimine el ya adjuntado", "Error");
                    return false;
                }
            }

            if (fileList != null && fileList.length > 0) {
                this.isFileAttaching = true;
                this.gastoService.uploadAttachTemp(fileList).subscribe(data => {
                    this.isFileAttaching = false;
                    if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
                        for (let i=0; i<data.Result.Archivos.length; i++) {
                            if (data.Result.Archivos[i] != null) {
                                this.item.Adjuntos.push(data.Result.Archivos[i]);
                            }
                        }
                    }
                    else
                        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
                },
                (err: HttpErrorResponse) => {
                    this.isFileAttaching = false;
                    this.sharedFunctions.handleError(err, true);
                })
            }
        }
    }

    onExistingFileAttachedDelete(item: any) {
        if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
            var index = this.item.Adjuntos.findIndex(f => f.Id == item.Id);

            if (index >= 0)
                this.item.Adjuntos.splice(index, 1);
        }
    }

    onNewFileAttachedDelete(item: any) {
        if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
            var index = this.item.Adjuntos.findIndex(f => f.Id == item.Id);

            if (index >= 0) {
                this.item.Adjuntos.splice(index, 1);
            }
        }
    }

//#endregion

//#region Movimientos

    getMovimientos(id: number) {
        var r = new SearchMovimientoRequest(null, null, true, "FechaMovimiento", null, null, null, null, null, null, null, null, null, null, null, null,
            null, null, id, null, null, null, null, null, null, null, null, null, null, null, null, true, null, null);
        this.isMovimientosSearching = true;

        this.movimientoService.search(r).subscribe(data => {
            this.isMovimientosSearching = false;
            this.movimientoList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isMovimientosSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    puedeVerMovimiento() {
        return (this.item != null && this.item.Id > 0 && this.tenantFeatureFlags?.HabilitarControlCaja && this.canMovimientoView);
    }

    openDialogCargaMovimiento(esGuardado: boolean) {
        const dialogRef = this.dialog.open(DialogCargaMovimientoComponent, {
            width: '80%',
            data: new DialogCargaMovimientoRequest(
            "Creación del Movimiento Asociado",
            "<b>Se crearán movimientos asociados al gasto que está guardando para el control de caja.</b><br/><br/>" +
                "Por favor complete los siguientes datos para poder llevar a cabo la carga de los movimientos:",
            "Asociar Movimientos",
            "Volver a editar el gasto",
            this.monedaList.find(f => f.Id == this.formGroup.get("MonedaId")?.value)?.Codigo || '',
            this.montoTotal1,
            this.formGroup.get("FechaGasto")?.value
            )
        });

        dialogRef.afterClosed().subscribe((result: DialogCargaMovimientoResponse) => {
            if (result != null && result.Accepted) {
            this.formGroup.patchValue(result);

            if (esGuardado)
                this.doSaveGasto(result.Movimientos);
            else
                this.doCrearMovimiento(result.Movimientos);
            }
        });
    }

    onCrearMovimiento() {
        this.openDialogCargaMovimiento(false);
    }

    doCrearMovimiento(datosMovimiento: DialogCargaMovimientoItem[]) {
        var r = new SaveGastoMovimientoDto(this.item.Id, datosMovimiento);
        this.isDeudaSaving = true;

        this.gastoService.crearMovimiento(r).subscribe(data => {
            this.isDeudaSaving = false;
            if (data != null && data.Success) {
                this.sharedFunctions.showMessage("Se generó éxitosamente el movimiento!", "Operación Exitosa!");
                this.sharedFunctions.reloadCurrentRoute();
            }
            else
                this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando crear el movimiento", "Error");
        },
        (err: HttpErrorResponse) => {
            this.isDeudaSaving = false;
            this.sharedFunctions.handleError(err, true);
        })
    }

    viewMovimiento(item: any) {
        if (!item || item.Id == null || item.Id <= 0) {
            this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
            return false;
        }

        if (!this.canMovimientoView) {
            this.sharedFunctions.showMessage("No tiene permisos para llevar a cabo la operación", "Error");
            return false;
        }

        this.router.navigate(['movimiento-view', item.Id]);
    }

//#endregion

    onFileAttachForAnalyze(event: any) {
        const dialogRef = this.dialog.open(DialogConfirmComponent, {
            data: new DialogConfirmRequest(
                "Confirmación de Operación",
                "Si adjunta un archivo para analizar, puede que pise alguno los datos que haya completado del movimiento.<br/><br/>¿Está seguro que desea continuar con la operación?",
                "Sí",
                "No"
            )
        });

        dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
            if (result != null && result.Accepted) {
                this.doFileAttachForAnalysis(event);
            }
        });
    }

    doFileAttachForAnalysis(event: any) {
        if (event?.target?.files != null && event.target.files.length > 0) {
            var fileList = event.target.files;

            if (fileList != null && fileList.length > 0) {
                this.isFileAttaching = true;
                this.gastoService.uploadAttachTemp(fileList).subscribe(data => {
                    this.isFileAttaching = false;
                    if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {

                        for (let i=0; i<data.Result.Archivos.length; i++) {
                            if (data.Result.Archivos[i] != null) {
                                this.doAnalisisDocumento(data.Result.Archivos[0]);
                            }
                        }
                    }
                    else
                        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir el archivo", "Error");
                },
                (err: HttpErrorResponse) => {
                    this.isFileAttaching = false;
                    this.sharedFunctions.handleError(err, true);
                })
            }
        }
    }

    doAnalisisDocumento(adjunto: GastoAdjunto) {
        var r = new SaveGastoFromDocumentRequestDto([ adjunto.UrlDocumento || '' ]);
        this.isFileAnalyzing = true;

        this.gastoService.generarDesdeDocumentos(r).subscribe(data => {
            this.isFileAnalyzing = false;
            if (data != null && data.Success && data.Result != null && data.Result.Gastos != null && data.Result.Gastos.length > 0) {
                var gastoAnalizado = data.Result.Gastos[0] as any;

                if (gastoAnalizado != null && gastoAnalizado.Success) {
                    this.formGroup.patchValue(gastoAnalizado);

                    if (this.item.Adjuntos == null)
                        this.item.Adjuntos = [];
                    this.item.Adjuntos.push(adjunto);

                    this.onAlicuotaIvaSelect();

                    if (gastoAnalizado.AlicuotaIvaId == null)
                        this.selectAlicuotaIvaDefault();

                    if (gastoAnalizado.MonedaId == null)
                        this.selectMonedaDefault();
                }
                else
                    this.sharedFunctions.showMessage("Ocurrió un error intentando analizar el archivo " + gastoAnalizado.NombreDocumento + (gastoAnalizado?.MensajeError?.length > 0 ? ": "+gastoAnalizado?.MensajeError : ""), "Error");
            }
            else
                this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando analizar el archivo", "Error");
        },
        (err: HttpErrorResponse) => {
            this.isFileAnalyzing = false;
            this.sharedFunctions.handleError(err, true);
        })
    }

    tieneMovimientoAsociado() {
        return (this.item != null && this.item.Id > 0 && this.movimientoList != null && this.movimientoList.length > 0);
    }

    onViewExpensa(id: number) {
        if (id == null || id <= 0) {
            this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
            return false;
        }

        if (!this.canExpensaView) {
            this.sharedFunctions.showMessage("No tiene permisos para llevar a cabo la operación", "Error");
            return false;
        }

        this.router.navigate(['expensa-edit', id]);
    }
}
